import React from "react";
import { proseToBullets } from "../../../../utils/proseToBullets";

/**
 * Renders a prose string as a styled bullet list.
 * If the text is already an array, it renders each item as-is.
 * Falls back to a single bullet when the text cannot be split.
 *
 * @param {Object}  props
 * @param {string|string[]}  props.text       - Prose text or array of strings
 * @param {string}  [props.className]          - Extra CSS class on the <ul>
 */
const SuggestionsBulletList = ({ text, className = "" }) => {
  if (!text) return null;

  const bullets = Array.isArray(text) ? text : proseToBullets(text);

  if (bullets.length === 0) return null;

  return (
    <ul className={`suggestions-bullet-list ${className}`.trim()}>
      {bullets.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};

export default SuggestionsBulletList;
